import { Reveal } from './Reveal';

const ROLES = [
  { who: 'Le chauffeur', verb: 'conduit.' },
  { who: 'Le mécanicien', verb: 'répare.' },
  { who: 'Le répartiteur', verb: 'coordonne.' },
  { who: "L'administration", verb: 'soutient les opérations.' },
];

const Flow = () => (
  <div className="relative mt-20" data-testid="philosophy-flow">
    <div className="absolute left-0 right-0 top-[7px] h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent hidden md:block" />
    <span className="pp-flow-dot hidden md:block" />
    <div className="grid md:grid-cols-4 gap-10 md:gap-6">
      {ROLES.map((r, i) => (
        <Reveal key={r.who} delay={i * 200} className="relative">
          <span className="block w-[15px] h-[15px] rounded-full border-2 border-amber-400 bg-[#0B0F19] mb-6" />
          <p className="text-white text-xl font-semibold">{r.who}</p>
          <p className="text-slate-400 text-lg">{r.verb}</p>
        </Reveal>
      ))}
    </div>
  </div>
);

export const Philosophy = () => (
  <section className="bg-[#0B0F19] py-28 md:py-44 overflow-hidden" data-testid="philosophy-section">
    <div className="max-w-6xl mx-auto px-6 sm:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold mb-6">Notre raison d'être</p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white max-w-4xl leading-[0.95]" data-testid="philosophy-title">
          C'est cette réflexion qui a donné naissance à ProPilote.
        </h2>
      </Reveal>
      <Reveal delay={200} className="mt-12 max-w-3xl">
        <p className="text-2xl sm:text-3xl text-slate-300 font-light leading-snug">
          Nous croyons qu'une information devrait être <span className="text-white font-medium">créée une seule fois</span>, puis <span className="text-white font-medium">circuler naturellement</span> vers ceux qui en ont besoin.
        </p>
      </Reveal>
      <Flow />
      <Reveal delay={300} className="mt-20">
        <p className="font-heading text-3xl sm:text-4xl uppercase font-bold tracking-tight text-amber-400">Et l'information suit son propre chemin.</p>
      </Reveal>
    </div>
  </section>
);
